import { render, staticRenderFns } from "./UiTableSellReport.vue?vue&type=template&id=2e835496&scoped=true&"
import script from "./UiTableSellReport.vue?vue&type=script&lang=js&"
export * from "./UiTableSellReport.vue?vue&type=script&lang=js&"
import style0 from "./UiTableSellReport.vue?vue&type=style&index=0&id=2e835496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e835496",
  null
  
)

export default component.exports